import React, { Component } from 'react'

import TableSteps from './TableSteps';
import TableAmountCategory from './TableAmountCategory';
import TableInformation from '../texts/TableInformation';
import TableRates from './TableRates';
import TableServices from './TableServices';
import TableFees from './TableFees';
import TableAmortization from './TableAmortization';
import TableVehicleDetails from './TableVehicleDetails';
import ContMessageI18N from '../../containers/ContMessageI18N';
import ResultError from './ResultError';

class FinanceFile extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	render() {
		var calculationResponse = this.props.vehicleDetails;
		var financeFile = this.props.financeFile;
		var developperView = this.props.settings.isDevelopperView;
		return (
			<div className='modal' id='modalFinanceFileGw' tabIndex="-1">
				<div className="modal-dialog modal-xl">
					<div className="modal-content">
						<div className="modal-header border-0" >
							<div className="container-fluid">
								<button type="button" className="btn-close float-end" data-bs-dismiss="modal" aria-label="Close" onMouseDown={(e) => e.currentTarget.blur()}></button>
							</div>
						</div>
						<div className="container-fluid">
							{calculationResponse != null
								&& calculationResponse.hasError
								&& <ResultError
									responseObject={calculationResponse}
									settings={this.props.settings}
								/>
							}
							{calculationResponse != null
								&& !calculationResponse.hasError
								&& calculationResponse.result != null
								&& <div className="row shadow rounded">
									{this.renderFinancialProductId()}
									{this.renderFinanceFileUsage()}
									{this.renderFinancialProperties()}
									{this.renderFinancialBasis()}
									{this.renderDeposit()}
									{this.renderResidual()}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.rates
										&& <div className="col col-12 col-lg-6">
											<TableRates
												title={this.getMessage('financefile.rates')}
												developperView={developperView}
												rates={financeFile.financialDetails.rates}
												i18nPrefix='financefile.rates'
												context={this.props.context}
												fieldname='rates'
											/>
										</div>
									}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.fees
										&& <div className="col col-12 col-lg-6">
											<TableFees
												title={this.getMessage('financefile.fees')}
												developperView={developperView}
												fees={financeFile.financialDetails.fees}
												i18nPrefix='financefile.fees'
												context={this.props.context}
												fieldname='fees'
											/>
										</div>
									}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.totals
										&& <div className="col col-12 col-lg-6">
											<TableAmountCategory
												title={this.getMessage('financefile.totals')}
												developperView={developperView}
												amounts={financeFile.financialDetails.totals}
												i18nPrefix='financefile.totals'
												context={this.props.context}
												fieldname='totals'
											/>
										</div>
									}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.additionnal
										&& <div className="col col-12 col-lg-6">
											<TableAmountCategory
												title={this.getMessage('financefile.additionnal')}
												developperView={developperView}
												amounts={financeFile.financialDetails.additionnal}
												i18nPrefix='financefile.additionnal'
												context={this.props.context}
												fieldname='additionnal'
											/>
										</div>
									}
									{financeFile && financeFile.vehicleDetails && financeFile.vehicleDetails.pricing
										&& <div className="col col-12 col-lg-6">
											<TableAmountCategory
												title={this.getMessage('financefile.vehicle')}
												developperView={developperView}
												amounts={financeFile.vehicleDetails.pricing}
												i18nPrefix='financefile.vehicle'
												context={this.props.context}
												fieldname='vehicle'
												collections={{ netOptionPrices: 'code', discounts: 'contributor' , appliedDiscountRefs :'appliedDiscountRefs'}}
											/>
										</div>
									}
									{financeFile && financeFile.vehicleDetails
										&& <div className="col col-12 col-lg-6">
											<TableVehicleDetails
												fieldname="vehicleDetails"
												developperView={developperView}
												title={this.getMessage('financefile.vehicleDetails')}
												vehicleDetails={financeFile.vehicleDetails}
												context={this.props.context}
											/>
										</div>
									}
									{financeFile && financeFile.vehicleDetails && financeFile.vehicleDetails.otrCosts
										&& <div className="col col-12 col-lg-6">
											<TableAmountCategory
												title={this.getMessage('financefile.otrCosts')}
												developperView={developperView}
												amounts={financeFile.vehicleDetails.otrCosts}
												i18nPrefix='financefile.otrCosts'
												context={this.props.context}
												fieldname='otrCosts'
											/>
										</div>
									}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.financialPaymentSteps
										&& <div className="col col-12 col-lg-6">
											<TableSteps
												fieldname="financialPaymentSteps"
												developperView={developperView}
												title={this.getMessage('financefile.financialPaymentSteps')}
												steps={financeFile.financialDetails.financialPaymentSteps}
												context={this.props.context}
											/>
										</div>
									}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.financialPaymentStepsInclFees
										&& <div className="col col-12 col-lg-6">
											<TableSteps
												fieldname="financialPaymentStepsInclFees"
												developperView={developperView}
												title={this.getMessage('financefile.financialPaymentStepsInclFees')}
												steps={financeFile.financialDetails.financialPaymentStepsInclFees}
												context={this.props.context}
											/>
										</div>
									}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.totalPaymentSteps
										&& <div className="col col-12 col-lg-6">
											<TableSteps
												fieldname="totalPaymentSteps"
												developperView={developperView}
												title={this.getMessage('financefile.totalPaymentSteps')}
												steps={financeFile.financialDetails.totalPaymentSteps}
												context={this.props.context}
											/>
										</div>
									}
									{financeFile && financeFile.services
										&& <div className="col col-12 col-lg-6">
											<TableServices
												fieldname="services"
												developperView={developperView}
												title={this.getMessage('financefile.services')}
												services={financeFile.services}
												context={this.props.context}
											/>
										</div>
									}
									{financeFile && financeFile.financialDetails && financeFile.financialDetails.amortizationSchedule
										&& <div className="col col-12 col-lg-6">
											<TableAmortization
												fieldname="amortizationSchedule"
												developperView={developperView}
												title={this.getMessage('financefile.amortization')}
												amortizationSchedule={financeFile.financialDetails.amortizationSchedule}
												context={this.props.context}
											/>
										</div>
									}
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderFinancialProductId() {
		const financeFile = this.props.financeFile;
		const developperView = this.props.settings.isDevelopperView;
		return (<React.Fragment>
			{financeFile && financeFile.financialDetails && financeFile.financialDetails.financialProductId
				&& <div className="col col-12 col-lg-6">
					<TableInformation
						title={this.getMessage('financefile.financialProductId')}
						developperView={developperView}
						values={financeFile.financialDetails.financialProductId}
						i18nPrefix='financefile.financialProductId'
						context={this.props.context}
						fieldname='financialProductId'
					/>
				</div>
			}
		</React.Fragment>);
	}
	renderFinanceFileUsage() {
		const financeFile = this.props.financeFile;
		const developperView = this.props.settings.isDevelopperView;
		return (<React.Fragment>
			{financeFile && financeFile.usages
				&& <div className="col col-12 col-lg-6">
					<TableInformation
						title={this.getMessage('financefile.usages')}
						developperView={developperView}
						values={financeFile.usages}
						i18nPrefix='financefile.usages'
						context={this.props.context}
						fieldname='usages'
					/>
				</div>
			}
		</React.Fragment>);
	}
	renderFinancialProperties() {
		const financeFile = this.props.financeFile;
		const developperView = this.props.settings.isDevelopperView;
		return (<React.Fragment>
			{financeFile && financeFile.financialDetails && financeFile.financialDetails.financialProperties
				&& <div className="col col-12 col-lg-6">
					<TableInformation
						title={this.getMessage('financefile.financialProperties')}
						developperView={developperView}
						values={financeFile.financialDetails.financialProperties}
						i18nPrefix='financefile.financialProperties'
						context={this.props.context}
						fieldname='financialProperties'
					/>
				</div>
			}
		</React.Fragment>);
	}
	renderFinancialBasis() {
		const financeFile = this.props.financeFile;
		const developperView = this.props.settings.isDevelopperView;
		return (<React.Fragment>
			{financeFile && financeFile.financialDetails && financeFile.financialDetails.basis
				&& <div className="col col-12 col-lg-6">
					<TableAmountCategory
						title={this.getMessage('financefile.basis')}
						developperView={developperView}
						amounts={financeFile.financialDetails.basis}
						i18nPrefix='financefile.basis'
						context={this.props.context}
						fieldname='basis'
					/>
				</div>
			}
		</React.Fragment>);
	}
	renderDeposit() {
		const financeFile = this.props.financeFile;
		const developperView = this.props.settings.isDevelopperView;
		return (<React.Fragment>
			{financeFile && financeFile.financialDetails && financeFile.financialDetails.deposit
				&& <div className="col col-12 col-lg-6">
					<TableAmountCategory
						title={this.getMessage('financefile.deposit')}
						developperView={developperView}
						amounts={financeFile.financialDetails.deposit}
						i18nPrefix='financefile.deposit'
						context={this.props.context}
						fieldname='deposit'
					/>
				</div>
			}
		</React.Fragment>);
	}
	renderResidual() {
		const financeFile = this.props.financeFile;
		const developperView = this.props.settings.isDevelopperView;
		return (<React.Fragment>
			{financeFile && financeFile.financialDetails && financeFile.financialDetails.residual
				&& <div className="col col-12 col-lg-6">
					<TableAmountCategory
						title={this.getMessage('financefile.residual')}
						developperView={developperView}
						amounts={financeFile.financialDetails.residual}
						i18nPrefix='financefile.residual'
						context={this.props.context}
						fieldname='residual'
					/>
				</div>
			}
		</React.Fragment>);
	}
}

export default (FinanceFile)


